var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('van-notify',{attrs:{"type":_vm.type},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_c('div',{staticClass:"w-full"},[_c('div',{staticClass:"truncate"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('div',[_c('span',[_vm._v(_vm._s(_vm.message))])])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }